import axios from "axios";

// TODO: set hostname + port dynamically

let url = window.location.host;

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN'
axios.defaults.xsrfCookieName = 'csrftoken'

export function getWagtailPage(id) {
  return axios.get(`//${url}/api/v2/pages/${id}/`);
}

export function getWagtailPageByPath(path) {
  // console.log(path);
  /* Newly added to avoid searching for /visual-computing-and-machine-intelligence/breast/[...] */
  if (path.substring(0, 7) == "/breast") {
    path = path.substring(7);
  }
  /* End newly added */
  return axios.get(
    `//${url}/api/v2/pages/find/?html_path=/visual-computing-and-machine-intelligence${path}`
  );
}

export function getWagtailPagesInMenu() {
  return axios.get(
    `//${url}/api/v2/pages/?show_in_menus=true&fields=_,html_url,title`
  );
}

export function getWagtailImage(id) {
  return axios.get(`//${url}/api/v2/images/${id}/`);
}

export function getWagtailDocument(id) {
  return axios.get(`//${url}/api/v2/documents/${id}/`);
}

export function getPaginationData(path, params = null) {
  return axios.get(`//${url}/api/v2/paginations/${path}/`, { params });
}

export function getSearchData(path, params = null) {
  return axios.get(`//${url}/api/v2/search/${path}/`, { params });
}

export function getLatestData(path, params = null) {
  return axios.get(`//${url}/api/v2/latest/${path}/`, { params });
}

export function getByFullURL(url, params = null) {
  return axios.get(url, { params });
}

export function getWagtailPageByParams(params = {}) {
  return axios.get(`//${url}/api/v2/pages/`, { params });
}

export function postNewDemo(formData) {
  return axios.post(`//${url}/api/v2/demo/`, formData, {
    "Content-Type": "multipart/form-data",
  });
}

export function downloadProjectTemplate(formData) {
  return axios.post(`//${url}/api/v2/demo/build/`, formData, {
    responseType: "arraybuffer",
  });
}
